var render = function render(){var _vm=this,_c=_vm._self._c;return _c('as-main-workorder-list',{ref:"asMainWorkorderList",attrs:{"staff-id":_vm.staffId,"no-bottom":"","add-button":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }